import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalAddressWhitelistBasic } from '@models/ss-api/responses/global.address.whitelist.basic';
import { AddGlobalAddressWhitelistRequest } from '@models/ss-api/requests/add.global.address.whitelist.request';
import { EditGlobalAddressWhitelistRequest } from '@models/ss-api/requests/edit.global.address.whitelist.request';

export interface IAddGlobalAddressWhitelist {
    Title: string;
    IsEditDialog: boolean;
    Item?: GlobalAddressWhitelistBasic;
}

@Component({
    selector: 'add-global-address-whitelist-dialog',
    styleUrls: ['./add.global.address.whitelist.dialog.scss'],
    templateUrl: './add.global.address.whitelist.dialog.html'
})

export class AddGlobalAddressWhitelist extends DialogComponent<IAddGlobalAddressWhitelist, boolean> implements IAddGlobalAddressWhitelist, OnInit {
    IsBusy: boolean;
    Title: string;
    IsEditDialog: boolean = false;
    Item: GlobalAddressWhitelistBasic;

    GlobalAddressWhitelistForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;

        this.GlobalAddressWhitelistForm = new FormGroup({
            'Address': new FormControl(this.IsEditDialog && this.Item ? this.Item.Address : '', [Validators.required]),
            'City': new FormControl(this.IsEditDialog && this.Item ? this.Item.City : '', [Validators.required]),
            'State': new FormControl(this.IsEditDialog && this.Item ? this.Item.State : '', [Validators.required]),
            'ZipCode': new FormControl(this.IsEditDialog && this.Item ? this.Item.ZipCode : '', [Validators.required]),
            'Country': new FormControl(this.IsEditDialog && this.Item ? this.Item.Country : '', [Validators.required])
        });
    }

    confirm() {
        if (!this.GlobalAddressWhitelistForm.valid) return false;
        this.IsBusy = true;
        this.result = true;

        let controls = this.GlobalAddressWhitelistForm.controls;

        if (this.IsEditDialog) {
            let request = new EditGlobalAddressWhitelistRequest();
            request.GlobalAddressWhiteListID = this.Item.ID;
            request.Address = controls['Address'].value;
            request.City = controls['City'].value;
            request.State = controls['State'].value;
            request.ZipCode = controls['ZipCode'].value;
            request.Country = controls['Country'].value;

            let disposable = this.api.EditGlobalAddressWhitelist(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then(() => { this.close(); }, () => { this.close(); });
                }
                disposable.unsubscribe();
            });
        } else {
            let request = new AddGlobalAddressWhitelistRequest();
            request.Address = controls['Address'].value;
            request.City = controls['City'].value;
            request.State = controls['State'].value;
            request.ZipCode = controls['ZipCode'].value;
            request.Country = controls['Country'].value;

            let disposable = this.api.AddGlobalAddressWhitelist(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then(() => { this.close(); }, () => { this.close(); });
                }
                disposable.unsubscribe();
            });
        }
    }

}
